export {type UIIconPropsWithoutChildren, UIIcon, type UIIconProps} from '../../../src/icon/UIIcon';
